import React from "react";
import "./Video.css";
import styled from "styled-components";
import { formatMessage } from "../utils/generic";

const MessageVideo = styled.div`
  .caption {
    // font-family: Plus Jakarta Sans;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
    margin-top: 10px;
  }
  .main-img-class {
    text-align: center;
    // background-color: #fff;
    // border-radius: 14px;
    // padding: 20px;
  }

  .msg-image__img {
    width: 240px;
    height: 135px;
    border-radius: 14px;
  }
`;

function Video({ message }) {
  const getYouTubeEmbedUrl = (url) => {
    const regex = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([^?&]+)/;
    const match = url.match(regex);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  };
  const videoUrl = message && message.content && message.content.link;
  const caption = (message && message.content && message.content.caption) || "";
  const youTubeEmbedUrl = getYouTubeEmbedUrl(videoUrl);
  return (
    <MessageVideo>
      <div className="msg-image__main">
        {youTubeEmbedUrl ? (
          <iframe
            width="320"
            height="240"
            className="msg-image__img-msg"
            src={youTubeEmbedUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
            allowFullScreen
            title="YouTube video"
          ></iframe>
        ) : (
          <video width="320" height="240" controls className="msg-image__img">
            <source src={videoUrl} />
            Your browser does not support the video tag.
          </video>
        )}
      </div>
      {caption && (
        <p
          className="caption"
          dangerouslySetInnerHTML={{ __html: formatMessage(caption) }}
        />
      )}
    </MessageVideo>
  );
}

export default Video;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Message Components/Video.js